import { FC, useCallback } from "react";
import { SearchSupplierItemResponse, getSupplierById, searchSuppliers } from "../../services/supplier-service";

import { CSSProperties } from "@mui/styles";
import Selector from "components/Selector";
import localisation from "../../localisation";

export type SelectedSupplierDetails = {
    id: number;
    name: string;
};

export type SupplierSelectedCallback = (supplierDetails: SelectedSupplierDetails | null) => void;

type SupplierSelectorProps = {
    onSelected: SupplierSelectedCallback;
    initialSupplierId?: number;
    id?: string;
    style?: CSSProperties;
    helperText?: string;
    fieldCompanyId: number;
    numberOfSuggestions?: number;
    required?: boolean;
    isValid?: (isValid: boolean) => void;
};

const SupplierSelector: FC<SupplierSelectorProps> = (props: SupplierSelectorProps) => {
    const { onSelected, required, isValid } = props;

    return (
        <Selector<number, SearchSupplierItemResponse>
            id={props.id}
            style={props.style}
            initialId={props.initialSupplierId}
            search={useCallback(
                (searchTerm) =>
                    searchSuppliers({
                        fieldCompanyId: props.fieldCompanyId,
                        name: searchTerm,
                    }),
                [props.fieldCompanyId]
            )}
            getById={getSupplierById}
            render={useCallback((supplier) => supplier.name, [])}
            onSelected={useCallback((supplier) =>  onSelected(!supplier ? null : { id: supplier.id, name: supplier.name }), [onSelected])}
            localisation={{
                ...localisation.supplierSelector,
                helperText: props.helperText,
            }}
            required={required}
            isValid={isValid}
        />
    );
};

export default SupplierSelector;
